import React, { memo } from 'react';
import { phoneNumberPatternWithZero } from 'store/entity/patterns';

import Input from 'components/Input';
import Select from 'components/Select';
import messages from './Messages';
import messages2 from './CompanyMember/Messages';
import { IOption } from 'components/Select/Select';
import { MemberInviteInputsWrapper, DeleteMember } from './styles';
import { withTitle } from '../../../components/withTitle';
import { ICompanyMember, IInvitedMember } from 'store/companies/companiesTypes';

interface IComponentProps {
  item: IInvitedMember;
  remove: any;
  indexKey: number;
  companyRoles: IOption[];
  defaultRoles: IOption[];
  onChangeValue: any;
  currentUserNames: string[];
  filterUserWithName: (name: string) => void;
  memberWithSamePhone?: ICompanyMember;
  toDeleteRoleIds: number[] | undefined;
}

class CompanyInviteView extends React.Component<IComponentProps> {
  shouldComponentUpdate(nextProps: IComponentProps) {
    // re-render when a item property change
    if (JSON.stringify(this.props.item) !== JSON.stringify(nextProps.item)) {
      return true;
    }
    return false;
  }
  render() {
    const {
      item,
      remove,
      indexKey,
      defaultRoles,
      companyRoles,
      onChangeValue,
      filterUserWithName,
      memberWithSamePhone,
      toDeleteRoleIds,
    } = this.props;
    const noSpaceName = item.name.replace(/\s+/, '');
    const foundSimilars = item.name.trim().includes(' ')
      ? this.props.currentUserNames.filter((it) => {
          const noSpace1 = it.replace(/\s+/, '');
          if (noSpaceName.includes(noSpace1) || noSpace1.includes(noSpaceName))
            return true;
          return false;
        })
      : [];

    return (
      <MemberInviteInputsWrapper>
        <DeleteMember type="x" color="red" onClick={remove} />
        <Input
          label={messages.userPhoneNumber}
          wrapperClassName="invite-member-input"
          id={`item.${indexKey}.phoneNumber`}
          type="text"
          icon="phone"
          pattern={phoneNumberPatternWithZero}
          value={item.phoneNumber}
          required={true}
          style={{ width: '200px' }}
          placeholder={messages.userPhoneNumber}
          autoComplete="off"
          onChange={(e) =>
            onChangeValue(`members.${indexKey}.phoneNumber`, e.target.value)
          }
        />
        <div>
          {withTitle(
            <Input
              label={messages.userName}
              wrapperClassName="invite-member-input"
              id={`item.${indexKey}.name`}
              type="text"
              icon="user"
              value={item.name}
              required={true}
              wrapperStyle={{ width: '200px' }}
              placeholder={messages.userName}
              autoComplete="off"
              onChange={(e) =>
                onChangeValue(`members.${indexKey}.name`, e.target.value)
              }
            />,
            messages2.nameHint,
            'top'
          )}
          {(foundSimilars?.length ?? 0) > 0 && (
            <span style={{ marginLeft: '40px' }}>
              <span>{messages.foundSimilarPersons}</span>
              {foundSimilars?.map((name, index) => {
                return (
                  <a
                    key={index}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      filterUserWithName(name);
                    }}
                  >
                    {' '}
                    {name}{' '}
                  </a>
                );
              })}
            </span>
          )}
        </div>
        <div>
          <Input
            label={messages.employeeId}
            id={`employee.${indexKey}.employeeId`}
            type="text"
            value={item.employeeId}
            style={{ width: '200px' }}
            onChange={(e) =>
              onChangeValue(`members.${indexKey}.employeeId`, e.target.value)
            }
          />
        </div>
        <div>
          <Select
            label={messages.roles}
            values={defaultRoles}
            options={companyRoles}
            multiChoice={true}
            letAddChip={false}
            placeholder={messages.addMemberRole}
            onChangeValues={(chips) =>
              onChangeValue(
                `members.${indexKey}.roles`,
                chips.map((c) => c.label)
              )
            }
          />
          {memberWithSamePhone && (
            <Select
              label={messages.currentMemberRoles}
              multiChoice={true}
              options={Object.values(memberWithSamePhone.roles)
                .filter((it) => it.id === it.sourceRoleId || !it.sourceRoleId)
                ?.map((it) => ({ value: it.id, label: it.name }))}
              values={Object.values(memberWithSamePhone.roles)
                .filter(
                  (it) =>
                    !toDeleteRoleIds?.includes(it.id) &&
                    (it.id === it.sourceRoleId || !it.sourceRoleId)
                )
                ?.map((it) => ({ value: it.id, label: it.name }))}
              onChangeValues={(selected) => {
                const toDelete = Object.values(
                  memberWithSamePhone.roles
                ).filter(
                  (it) =>
                    !selected.find((s) => it.id === s.value) &&
                    (it.id === it.sourceRoleId || !it.sourceRoleId)
                );
                onChangeValue(
                  `members.${indexKey}.toDeleteRoleIds`,
                  toDelete.map((it) => it.id)
                );
              }}
            />
          )}
        </div>
      </MemberInviteInputsWrapper>
    );
  }
}

export default memo(CompanyInviteView);
